/**
 * Hook for checking plan entitlements in web app.
 * Provides methods to check if a feature is available or if a limit is exceeded.
 */

import type { PlanFeature, PlanLimitKey, PlanTier } from '@tilly/shared';
import { hasFeature, getLimit } from '@tilly/shared';
import { useBusinessStore } from '../stores/business';

export interface UseEntitlementsReturn {
  plan: string;
  hasFeature: (feature: PlanFeature) => boolean;
  getLimit: (limitKey: PlanLimitKey) => number;
}

export function useEntitlements(): UseEntitlementsReturn {
  const activePlan = useBusinessStore((s) => s.activePlan);
  const plan = activePlan || 'team';

  return {
    plan,
    hasFeature: (feature: PlanFeature) => hasFeature(plan as PlanTier, feature),
    getLimit: (limitKey: PlanLimitKey) => getLimit(plan as PlanTier, limitKey),
  };
}
